<template>
  <!-- TODO: Customize the below to fit EPMA -->
  <tr>
    <!-- <td data-label="Address">
      <strong>
        <router-link :to="{ path: epma.uuid, append: true }">
          {{ epma.address }}
        </router-link>
      </strong>
    </td> -->
    <td data-label="Property">
        <router-link v-if="epma.Property" :to="'/database-manager/properties/' + epma.Property.uuid">
        {{ epma.Property.address }},
        </router-link>
        <p v-else>N/A</p>
    </td>
    <td data-label="Strata Plan Number">
      <span v-if="epma.strataPlanNumber">
        {{ epma.strataPlanNumber }}
      </span>
      <span v-else>TBA</span>
    </td>
    <td data-label="Company">
      <router-link 
        v-if="epma.Company"
        :to="'/database-manager/companies/' + epma.Company.uuid">
        {{ epma.Company.name }}
      </router-link>
      <p v-else> 
        N/A
      </p>
    </td>
    <td data-label="OC Manager">
      <router-link 
        v-if="epma.Account"
        :to="'/database-manager/oc-managers/' + epma.Account.uuid">
        {{ epma.Account.fullName }}
      </router-link>
      <p v-else> 
        N/A
      </p>
    </td>
    <!-- <td data-label="OC Manager Email">
      <span v-if="epma.Account">
        {{ epma.Account.email }}
      </span>
      <span v-else> {{ epma.ocManagerEmail }}</span>
    </td>
    <td data-label="OC Manager Phone">
      <span v-if="epma.Account">
        {{ epma.Account.phone }}
      </span>
      <span v-else> {{ epma.ocManagerPhone }}</span>
    </td> -->
    <td data-label="Subscription Level">
      <span v-if="epma.fullSubscription" class="strong-600" >Full</span>
      <span v-else class="strong-600" >Standard</span>
    </td>
    <td data-label="Lots">
      <span v-if="epma.totalLots">
        {{ epma.totalLots }}
      </span>
      <span v-else>TBA</span>
    </td>
    <td data-label="Annual Cost">
      {{ epma.annualCost }}
    </td>
    <td data-label="Pro Rata">
      {{ epma.proRata }}
    </td>
    <td data-label="Amount">
      {{ epma.amount }}
    </td>
    <td data-label="Start Date">
      {{ epma.startDate | date_time_format }}
    </td>
    <td data-label="End Date">
      {{ epma.endDate | date_time_format }}
    </td>
    <td data-label="Email Sent ">
      <i v-if="epma.emailSent" class="fa fa-check" style="color:green"></i>
      <i v-else class="fa fa-times" style="color:red"></i>
    </td>
    <td data-label="Signed">
      <i v-if="epma.signed" class="fa fa-check" style="color:green"></i>
      <i v-else class="fa fa-times" style="color:red"></i>
    </td>
    <!-- <td data-label="Insurance Company">
      {{ epma.insuranceCompany }}
    </td> -->
  <!-- <button @click="logEPMA">
    Test
  </button> -->


    <!-- <td data-label="Access Instructions">
      <div class="d-sm-none">
        <br/>
        <p class="text-left mb-0 mt-2">
          {{ epma.accessInstructions }}
        </p>
      </div>
      <span class="d-none d-sm-block">
        {{ epma.accessInstructions }}
      </span>
    </td> -->
    <td class="text-center">
      <dropdown 
        :title="'EPMA Actions'"
        :icon="'fa fa-building'"
        :actions="EPMAActions"
        @action="executeAction($event, epma)">
      </dropdown>
    </td>
  </tr>
</template>

<script>
  import Dropdown from '@/components/ui/Dropdown'
  import {
    SET_EPMA_ACTIONS,
    EDIT_EPMA,
    MAIL_EPMA,
    INVOICE_EPMA,
    DELETE_EPMA,
    REQUEST_EPMA_SIGNATURE,
    GENERATE_COMPANY_PORTFOLIO,
    VIEW_COMPANY_PORTFOLIO
  } from '@/vuex/types'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'EPMARow',
    components: {
      Dropdown
    },
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      epma () {
        if (this.$route.meta.client) {
          this.$store.commit(SET_EPMA_ACTIONS)
        }
        return {
          Company: {},
          ...this.object
        }
      },
      ...mapGetters([
        'EPMAActions'
      ])
    },
    methods: {
      async executeAction (action, payload) {
        await this[action](payload)
      },
      logEPMA() {
        console.log(this.epma);
      },
      ...mapActions([
        MAIL_EPMA,
        INVOICE_EPMA,
        EDIT_EPMA,
        DELETE_EPMA,
        REQUEST_EPMA_SIGNATURE,
        GENERATE_COMPANY_PORTFOLIO,
        VIEW_COMPANY_PORTFOLIO
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/EPMA.vue